import {inject, Injectable, signal} from '@angular/core';
import {AppNotification} from './notification.model';
import {delay, Observable, of} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {GatewayResponse} from '../../../core/auth/api/auth-api.service';
import {unwrapGateway} from '../../utils/gateway.utils';

@Injectable({
	providedIn: 'root'
})
export class NotificationService {
	private http = inject(HttpClient);

	private readonly _notifications = signal<AppNotification[]>([]);
	readonly notifications = this._notifications.asReadonly();

	getAll(userId: string) {
		return this.http.get<GatewayResponse<AppNotification>>(
			`${environment.api.baseUrl}/tickets/api/v1/notifications/recipient/${userId}`
		).pipe( unwrapGateway<AppNotification>() )
	}

	setAsRead(id: string) {
		return this.http.patch<AppNotification>(`${environment.api.baseUrl}/tickets/api/v1/notifications/${id}/read`, {});
	}


	markAllAsRead(): Observable<AppNotification[]> {
		const updated = this._notifications().map(n =>
			n.read ? n : { ...n, read: true }
		);

		this._notifications.set(updated);

		return of(updated).pipe(delay(300));
	}

	unreadCount() {
		return this.notifications().filter(n => !n.read).length;
	}
}
